"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RichWise_Website_API.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfLiffUnbindModel = instanceOfLiffUnbindModel;
exports.LiffUnbindModelFromJSON = LiffUnbindModelFromJSON;
exports.LiffUnbindModelFromJSONTyped = LiffUnbindModelFromJSONTyped;
exports.LiffUnbindModelToJSON = LiffUnbindModelToJSON;
exports.LiffUnbindModelToJSONTyped = LiffUnbindModelToJSONTyped;
/**
 * Check if a given object implements the LiffUnbindModel interface.
 */
function instanceOfLiffUnbindModel(value) {
    if (!('lineId' in value) || value['lineId'] === undefined)
        return false;
    return true;
}
function LiffUnbindModelFromJSON(json) {
    return LiffUnbindModelFromJSONTyped(json, false);
}
function LiffUnbindModelFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'lineId': json['lineId'],
    };
}
function LiffUnbindModelToJSON(json) {
    return LiffUnbindModelToJSONTyped(json, false);
}
function LiffUnbindModelToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'lineId': value['lineId'],
    };
}
